import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
import Styles from './FeatureItem.styles';
import FluidImageWrapper from '../FluidImageWrapper';
import ImageFluid from '../ImageFluid';

const Title = styled(Text)`
  ${Styles.title};
`;
const Description = styled(Text)`
  ${Styles.description};
`;
const CallToAction = styled.a`
  ${Styles.callToAction};
`;
const Container = styled.div`
  ${Styles.container};
`;

const ImageWrapper = styled.div`
  ${Styles.imageWrapper};
`;

const InnerWrapper = styled.div`
  ${Styles.innerwrapper};
`;

/**
 * Steps component
 * @property {Object} props - component props
 * @returns {JSX}
 */
const FeatureItem = ({
  title, description, callToAction, link, className, icon
}) => {
  return (
    <Container className={className} style={{ textAlign: 'center', alignItems: 'center' }}>
      <InnerWrapper>
        <ImageWrapper style={{ width: '100px', height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
          <img src={icon} style={{ height: '120px' }} alt={callToAction} />
        </ImageWrapper>
        <Title className="cbx-bold" tag="h3">
          {title}
        </Title>
        <Description tag="p">
          {description}
        </Description>
        {callToAction && <CallToAction href={link} alt={callToAction}>
          {callToAction}
        </CallToAction>}
      </InnerWrapper>
    </Container>
  );
};

FeatureItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  callToAction: PropTypes.string,
  link: PropTypes.string,
  className: PropTypes.string
};

export default FeatureItem;
